import { gql } from '@apollo/client'
import IMAGE_FRAGMENT from './IMAGE_FRAGMENT'

const BRAND_VALUES_FRAGMENT = gql`
    ${IMAGE_FRAGMENT}
    fragment BrandValuesFields on BrandValueEntity {
        id
        attributes {
            Name
            Name_Fr
            Color
            Icon {
                ...ImageFields
            }
        }
    }
`

export const BRAND_VALUES_FRAGMENT_COLLECTION = gql`
    ${BRAND_VALUES_FRAGMENT}
    fragment BrandValuesCollection on BrandValueRelationResponseCollection {
        data {
            ...BrandValuesFields
        }
    }
`

export const BRAND_VALUES_FRAGMENT_COLLECTION_DIRECT = gql`
    ${BRAND_VALUES_FRAGMENT}
    fragment BrandValuesCollectionDirect on BrandValueEntityResponseCollection {
        data {
            ...BrandValuesFields
        }
    }
`

export default BRAND_VALUES_FRAGMENT
